/*
 *
 *  actions
 *
 */

import {
 
  LOAD_PRINT,
  LOAD_PRINT_SUCCESS,
  LOAD_PRINT_ERROR,


  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_ASSIGN_HISTORY,
  LOAD_ASSIGN_HISTORY_SUCCESS,
  LOAD_ASSIGN_HISTORY_ERROR,

  UPDATE_PROCESS,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_ERROR,

  ASSIGN_VENDOR,
  ASSIGN_VENDOR_SUCCESS,
  ASSIGN_VENDOR_ERROR,

  LOAD_VENDOR,
  LOAD_VENDOR_SUCCESS,
  LOAD_VENDOR_ERROR,

  LOAD_CLIENT_EVENT,
  LOAD_CLIENT_EVENT_SUCCESS,
  LOAD_CLIENT_EVENT_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
   // type: LOAD_RECORDS_VALID_CACHE,
  }
}


export function loadPrint(searchFilter) {
  return {
    type: LOAD_PRINT,
    searchFilter,
  }
}


export function loadPrintSuccess(print_data, success) {
  return {
    type: LOAD_PRINT_SUCCESS,
    print_data,
    success,
  }
}


export function loadPrintError(error) {
  return {
    type: LOAD_PRINT_ERROR,
    error,
  }
}



export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

export function updateProcess(submitStatus) {
  return {
    type:UPDATE_PROCESS,
    submitStatus,
  }
}

export function updateProcessSuccess() {
  return {
    type: UPDATE_PROCESS_SUCCESS,
  }
}


export function updateProcessError(error) {
  return {
    type: UPDATE_PROCESS_ERROR,
    error,
  }
}

export function assignVendor(vendor_details) {
  return {
    type: ASSIGN_VENDOR,
    vendor_details,
  }
}

export function assignVendorSuccess(vendor_details) {
  return {
    type: ASSIGN_VENDOR_SUCCESS,
    vendor_details
    
  }
}

export function assignVendorError(error) {
  return {
    type: ASSIGN_VENDOR_ERROR,
    error,
  }
}

export function loadVendor(searchFilter) {
  return {
    type: LOAD_VENDOR,
    searchFilter,
  }
}


export function loadVendorSuccess(vendor_data, success) {
  return {
    type: LOAD_VENDOR_SUCCESS,
    vendor_data,
    success,
  }
}


export function loadVendorError(error) {
  return {
    type: LOAD_VENDOR_ERROR,
    error,
  }
}

export function loadAssignHistory(historyData) {
  return {
    type: LOAD_ASSIGN_HISTORY,
    historyData,
  }
}


export function loadAssignHistorySuccess(historyDetails, success) {
  return {
    type: LOAD_ASSIGN_HISTORY_SUCCESS,
    historyDetails,
    success,
  }
}


export function loadAssignHistoryError(error) {
  return {
    type:  LOAD_ASSIGN_HISTORY_ERROR,
    error,
  }
}
//loadClientEvent

export function loadClientEvent(searchFilter) {
  return {
    type: LOAD_CLIENT_EVENT,
    searchFilter,
  }
}


export function loadClientEventSuccess(clientEvent_data, success) {
  return {
    type: LOAD_CLIENT_EVENT_SUCCESS,
    clientEvent_data,
    success,
  }
}


export function loadClientEventError(error) {
  return {
    type: LOAD_CLIENT_EVENT_ERROR,
    error,
  }
}
const actions = {
  loadPrint,
  loadPrintSuccess,
  loadPrintError,


  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  updateProcess,
  updateProcessSuccess,
  updateProcessError,

  assignVendor,
  assignVendorSuccess,
  assignVendorError,

  loadVendor,
  loadVendorSuccess,
  loadVendorError,

  loadAssignHistory,
  loadAssignHistorySuccess,
  loadAssignHistoryError,

  loadClientEvent,
  loadClientEventSuccess,
  loadClientEventError

}

export default actions
